module.exports = __webpack_public_path__ + "static/media/Perufarma.e2366246.jfif";